export default {
    install: false,
    vw: 0,
    vh: 0,
};